import { render } from "./subheader-edit.vue?vue&type=template&id=105fe169"
import script from "./subheader-edit.vue?vue&type=script&lang=js"
export * from "./subheader-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__